import { Star} from "lucide-react";
import { useState } from "react";

function RatingStars({ value, onChange }: { value: number; onChange: (val: number) => void }) {
  const [hover, setHover] = useState<number | null>(null);

  return (
    <div className="flex items-center gap-1 mt-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => onChange(star)}
          onMouseEnter={() => setHover(star)}
          onMouseLeave={() => setHover(null)}
          className="p-1"
        >
          <Star
            className={`h-6 w-6 transition-colors ${
              (hover ?? value) >= star ? "fill-yellow-400 text-yellow-400" : "text-gray-300"
            }`}
          />
        </button>
      ))}
    </div>
  );
}

export default RatingStars;
